module.exports = __webpack_public_path__ + "img/L_4S.56805bb0.png";